import branchManagementTntBypassCodeComponent from './tnt_bypass_code.component';

let branchManagementTntBypassCodeModule = angular.module('branchManagementTntBypassCode', [])
  .component('branchManagementTntBypassCode', branchManagementTntBypassCodeComponent)
  .name;

export default branchManagementTntBypassCodeModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tnt_bypass_code/index.js